import { createSlice } from "@reduxjs/toolkit";
import { getLocationNamesSelectors } from "./thunk";
import { IState } from "./types";

const initialState: IState = {
  error: null,
  responseStatus: "idle",
  locationNames: [],
};

export const locationNamesSlice = createSlice<IState, {}>({
  name: "locationNamesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      getLocationNamesSelectors.fulfilled,
      (state, { payload }) => {
        state.locationNames = payload;
      }
    );
  },
});

export default locationNamesSlice.reducer;
